<!-- SIGN IN -->

<div [hidden]="signUp || forgotPass">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5">{{ 'SIGN_IN.TITLE' | translate }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" [hidden]="signInMessageShow">
        <form [formGroup]="signInProfileForm" (ngSubmit)="signInHandleSubmit()">
          <div class="mb-3" [hidden]="confirmMailMessage !== '' || confirmMailError !== ''">
            <label for="signin-email-input" class="form-label">{{ 'SIGN_IN.EMAIL_LABEL' | translate }}</label>
            <input
              type="email"
              class="form-control"
              id="signin-email-input"
              formControlName="email"
              [class.is-invalid]="signInProfileForm.get('email')?.invalid && signInProfileForm.get('email')?.touched"
              placeholder="{{ 'SIGN_IN.EMAIL_PLACEHOLDER' | translate }}"
            />
            <div class="invalid-feedback">
              {{ 'SIGN_IN.EMAIL_INVALID' | translate }}
            </div>
          </div>
          <div class="mb-3" [hidden]="resendConfirm">
            <label for="signinpassword" class="form-label">{{ 'SIGN_IN.PASSWORD_LABEL' | translate }}</label>
            <input
              type="password"
              class="form-control"
              id="signinpassword"
              formControlName="password"
              [class.is-invalid]="signInProfileForm.get('password')?.invalid && signInProfileForm.get('password')?.touched"
              placeholder="{{ 'SIGN_IN.PASSWORD_PLACEHOLDER' | translate }}"
            />
            <div class="invalid-feedback">
              {{ 'SIGN_IN.PASSWORD_INVALID' | translate }}
            </div>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <button type="submit" class="btn btn-secondary rounded w-100" [disabled]="isButtonDisabled" [hidden]="resendConfirm">
              {{ 'SIGN_IN.SUBMIT' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-primary rounded w-100"
              [hidden]="!resendConfirm || confirmMailMessage !== '' || confirmMailError !== ''"
              (click)="resendConfirmSubmit()"
            >
              {{ 'SIGN_IN.RESEND_CONFIRM' | translate }}
            </button>
            <div class="d-flex flex-row justify-content-between align-items-center">
              <div class="pt-3">
                <div [hidden]="!signInMessageShowError || confirmMailMessage !== '' || confirmMailError !== ''">{{ signInMessage }}</div>
                <div [hidden]="confirmMailMessage === '' && confirmMailError === ''">{{ confirmMailMessage }}{{ confirmMailError }}</div>
              </div>
              <div class="link-primary small align-self-end pt-2" (click)="toggleSignInForgotPass()" [hidden]="resendConfirm">
                {{ 'SIGN_IN.FORGOT_PASSWORD' | translate }}
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-body" [hidden]="!signInMessageShow">
        <div>{{ 'SIGN_IN.LOGGED_IN_MESSAGE' | translate }}</div>
      </div>
      <div class="modal-footer">
        <div [hidden]="signInMessageShowSucceed">{{ 'SIGN_IN.NO_ACCOUNT' | translate }}</div>
        <div class="btn btn-link" [hidden]="signInMessageShowSucceed" (click)="toggleSignInUp()">
          {{ 'SIGN_IN.SIGN_UP' | translate }}
        </div>
        <div class="btn btn-link" [hidden]="!signInMessageShowSucceed" data-bs-dismiss="modal">
          {{ 'SIGN_IN.CLOSE' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Forgot pass -->

<div [hidden]="!forgotPass">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5">{{ 'FORGOT_PASS.TITLE' | translate }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" [hidden]="passcode || loadingPasscode">
        <form [formGroup]="forgotPassProfileForm" (ngSubmit)="forgotPassHandleSubmit()">
          <div class="mb-3">
            <label for="reset-pass" class="form-label">{{ 'FORGOT_PASS.EMAIL_LABEL' | translate }}</label>
            <input
              type="email"
              class="form-control"
              id="reset-pass"
              formControlName="email"
              [class.is-invalid]="forgotPassProfileForm.get('email')?.invalid && forgotPassProfileForm.get('email')?.touched"
              placeholder="{{ 'FORGOT_PASS.EMAIL_PLACEHOLDER' | translate }}"
            />
            <div class="invalid-feedback">
              {{ 'FORGOT_PASS.EMAIL_INVALID' | translate }}
            </div>
          </div>
          <div class="d-flex flex-column justify-content-end align-items-center">
            <button type="submit" class="btn btn-secondary rounded w-100">
              {{ 'FORGOT_PASS.RESET_BUTTON' | translate }}
            </button>
          </div>
        </form>
      </div>
      <div class="modal-body" [hidden]="!loadingPasscode">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'FORGOT_PASS.LOADING' | translate }}</span>
        </div>
      </div>
      <div class="modal-body" [hidden]="!completedPasscode">
        <div>{{ 'FORGOT_PASS.EMAIL_SENT_MESSAGE' | translate }}</div>
      </div>
      <div class="modal-footer">
        <div [hidden]="signInMessageShowSucceed">{{ 'FORGOT_PASS.ALREADY_MEMBER' | translate }}</div>
        <div class="btn btn-link" [hidden]="signInMessageShowSucceed" (click)="toggleSignInForgotPass()">
          {{ 'FORGOT_PASS.SIGN_IN' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- SIGN UP -->

<div [hidden]="!signUp">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5">{{ 'SIGN_UP.TITLE' | translate }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" [hidden]="signUpMessageShow">
        <form [formGroup]="profileForm" (ngSubmit)="handleSubmit()">
          <div class="mb-3">
            <label for="email-input" class="form-label">{{ 'SIGN_UP.EMAIL_LABEL' | translate }}</label>
            <input
              type="email"
              class="form-control"
              id="email-input"
              formControlName="email"
              [class.is-invalid]="profileForm.get('email')?.invalid && profileForm.get('email')?.touched"
              placeholder="{{ 'SIGN_UP.EMAIL_PLACEHOLDER' | translate }}"
            />
            <div class="invalid-feedback">
              {{ 'SIGN_UP.EMAIL_INVALID' | translate }}
            </div>
          </div>
          <div class="mb-3">
            <label for="password" class="form-label">{{ 'SIGN_UP.PASSWORD_LABEL' | translate }}</label>
            <input
              type="password"
              class="form-control"
              id="password"
              formControlName="password"
              [class.is-invalid]="profileForm.get('password')?.invalid && profileForm.get('password')?.touched"
              placeholder="{{ 'SIGN_UP.PASSWORD_PLACEHOLDER' | translate }}"
            />
            <div class="invalid-feedback">
              {{ 'SIGN_UP.PASSWORD_INVALID' | translate }}
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <button type="submit" class="btn btn-secondary rounded w-100" [disabled]="isButtonDisabled">
              {{ 'SIGN_UP.SUBMIT' | translate }}
            </button>
          </div>
        </form>
      </div>
      <div class="modal-body" [hidden]="!signUpMessageShow">
        <div>
          {{ 'SIGN_UP.CONFIRMATION_SENT' | translate }} <span class="fw-bold">{{ signUpMessage }}</span>
        </div>
      </div>
      <div class="modal-body" [hidden]="!signUpMessageShowError">
        <div class="text-center">{{ signUpMessage }} 🤔</div>
      </div>
      <div class="modal-footer">
        <div [hidden]="signUpMessageShowSucceed">{{ 'SIGN_UP.ALREADY_MEMBER' | translate }}</div>
        <div class="btn btn-link" [hidden]="signUpMessageShowSucceed" (click)="toggleSignInUp()">
          {{ 'SIGN_UP.SIGN_IN' | translate }}
        </div>
        <div class="btn btn-link" [hidden]="!signUpMessageShowSucceed" data-bs-dismiss="modal">
          {{ 'SIGN_UP.CLOSE' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
